// detectHashAndScrollTo
//
//
// Author: tobias.wolf@wagnerwagner.de


(function () {
  // elements
  const anchorLinkElements = document.querySelectorAll(`a[href^="${location.pathname.substr(1)}#"]`);

  // functions
  function getOffsetTopOfFullBackgroundImage(hash) {
    let returnValue = false;
    const element = document.getElementById(hash);
    if (element) {
      if (element.classList.contains('full-background-image__popup')) {
        returnValue = element.parentElement.parentElement.offsetTop;
        if (!window.matchMedia('(min-width: 928px)').matches) {
          returnValue += element.offsetTop;
        }
      } else {
        returnValue = element.offsetTop;
      }
    }
    return returnValue;
  }
  function getOffsetHeight(hash) {
    let returnValue = false;
    const element = document.getElementById(hash);
    if (element) {
      returnValue = element.offsetHeight;
    }
    return returnValue;
  }
  function calculateDuration(elementOffsetTop) {
    let duration = 0;
    const scrollTop = document.documentElement.scrollTop || document.body.parentNode.scrollTop || document.body.scrollTop;
    duration = Math.abs(scrollTop - elementOffsetTop) / 4;
    duration = duration > 1500 ? 1500 : duration;
    return duration;
  }
  function isInView(hash) {
    let _isInView = false;
    const scrollTop = document.documentElement.scrollTop || document.body.parentNode.scrollTop || document.body.scrollTop;
    const { innerHeight } = window;
    const elementOffsetTop = getOffsetTopOfFullBackgroundImage(hash);
    const elementOffsetHeight = getOffsetHeight(hash);
    if (elementOffsetTop >= scrollTop
       && (elementOffsetTop + elementOffsetHeight) <= (window.pageYOffset + innerHeight)) {
      _isInView = true;
    }
    return _isInView;
  }
  function scroll(hash) {
    if (hash.length >= 1) {
      const element = document.getElementById(hash);
      if (element) {
        element.setAttribute('tabindex', '0');
        if (!isInView(hash)) {
          let elementOffsetTop = 0;
          let duration = 200;
          elementOffsetTop = getOffsetTopOfFullBackgroundImage(hash);
          if (elementOffsetTop) {
            duration += calculateDuration(elementOffsetTop);
            SCROLLING.scrollTop(null, elementOffsetTop, duration, () => {
              // console.log('change url (after scrolling): ' + location.pathname + '#' + hash);
              window.history.replaceState(null, null, `${location.pathname}#${hash}`);
              element.focus();
            });
          }
        } else {
          window.history.replaceState(null, null, `${location.pathname}#${hash}`);
          element.focus();
        }
      }
    }
  }

  function handleAnchorLinkClick(e) {
    e.preventDefault();
    const { href } = e.currentTarget;
    const hash = href.substr(href.indexOf('#') + 1);
    // only scroll when link hash is not current location hash
    if (hash !== location.hash.substr(1)) {
      scroll(hash);
    }
    ARTICLE_LIST.hide();
  }

  // add event listener
  for (let i = 0; i < anchorLinkElements.length; i++) {
    anchorLinkElements[i].addEventListener('click', handleAnchorLinkClick);
  }
  window.addEventListener('hashchange', scroll);

  // scroll
  setTimeout(() => {
    scroll(location.hash.substr(1));
  }, 500); // wait to give the user a chance to orient
}());
